<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<!-- <div class="form-row">
										<div class="col-md-8">
											<div class="btn-group" style="float: right;">
												<button class="btn btn-primary btn-sm" @click="modalToggle('NEW')" >
													<fa icon="add"/>&nbsp;
													{{ $t('default.button.add') }}
												</button>
											</div>
										</div>
									</div> -->
									<div class="form-row">
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
												</label>
												<select v-model="instance.prsStore" class="form-control" multiple>
													<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id">
													{{ prsStore.storeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsType')}}
												</label>
												<select v-model="instance.prsType" class="form-control" multiple>
													<option v-for="prsType in prsTypeList" :value="prsType.id" :key="prsType.id">
													{{ prsType.typeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsFunction')}}
												</label>
												<select v-model="instance.prsFunction" class="form-control" multiple>
													<option v-for="prsFunction in prsFunctionList" :value="prsFunction.id" :key="prsFunction.id">
													{{ prsFunction.functionName}}
													</option>
												</select>	
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t(instanceClassAttr.instanceClass+'.firstName')}}</label>
												<input type="text" v-model="instance.firstName" class="form-control" />
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{ $t(instanceClassAttr.instanceClass+'.lastName')}}</label>
												<input type="text" v-model="instance.lastName" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.pay')} ) }}</label>
												<input type="number" step="any" v-model="instance.payInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {} "/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.pay')})}}</label>
												<input type="number" step="any" v-model="instance.payEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {} "/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.pay')})}}</label>
												<input type="number" step="any" v-model="instance.paySup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {} "/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>
										
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.active')}}
												</label>
												<select v-model="instance.active" class="form-control">
													<option :value="true">Oui</option>
													<option :value="false">Non</option>
												</select>										
											</div>
										</div>
										
									</div> <!--end form-row-->
									<div style="text-align:center">
										<!-- <b-button class="btn btn-danger btn-sm"
											@click="changeMat()">
											<fa icon="check"/>
												Change
										</b-button>
										&ensp; -->
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div class="card mb-4" style="width:100%">
							<div class="card-header">
								<div class="form-row">
									<div class="col-md-6">
										
									</div>

								</div>
							</div>
							<div class="card-body">
								<div class="overflow-auto">
									<g-chart css-classes="chart-pie"
										:type="typeChart"
										:options="chartOptions"
										:data="chartData"
									/>
								</div>
							</div>
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import { GChart } from "vue-google-charts";
	export default {
		name: 'prsPersonList',
		props: {
			type: {
				type: String,
				default: '',
				required: false
			}
		},
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'g-chart': GChart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('prsperson.label'),
				pageTitle: this.$t('prsperson.list.all'),
				pageIcon: 'users',
				instanceClassAttr: {
					instanceClass: 'prsperson',
					routerShow: 'prspersonshow',
					titleIndex: 'nav.prs',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '10%', 
						actAdd: true, 
						actGet: true, 
						actEdit: false, 
						actDel: false, 
						actPrint: 'produce'
					},
					attrsList: [
						{attrName: 'mat', attrCol: '18%', searchable: true, sortable: true, attrRep: ''},
						{attrName: 'typeCivility', attrCol: '7%', searchable: true, sortable: true, attrRep: ''},
						{attrName: 'prsPersonLib', attrRep: 'fullNameCiv()', attrCol: '23%', searchable: false, sortable: true},
						{attrName: 'phoneAddress', attrCol: '12%', searchable: true, sortable: true},
						{attrName: 'prsTypeLib', attrCol: '8%', searchable: true, sortable: true},
						{attrName: 'activeLib', attrCol: '7%', searchable: false, sortable: true, attrRep: ''},
						{attrName: 'dateEntry', attrCol: '15%', searchable: false, sortable: true},
					]
				},
				instance: {
					prsType: [],
					prsFunction: [],
					prsService: [],
					prsStore: [],
					firstName: '',
					lastName: '',
					pay: '',
					active: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				},
				
				prsTypeList: [],
				prsFunctionList: [],
				prsServiceList: [],
				prsStoreList: [],
				typeCivilityList:[
					{id:'M.', label:'Monsieur'},
					{id:'Mme', label:'Madame'},
					{id:'Mlle', label:'Mademoiselle'},
					{id:'Sté', label:'Société'}
				],
				amountLetter: {},
				chartOptions: {
					width: 'auto',
					height: 500
				},
				chartData: [],
				typeChart: 'PieChart',
				typeStat: 'typeCivility'	
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
			
				// GET LIST prstype
				await this.$store.dispatch('axiosGet', {
					domain: 'prstype'
				})
				.then(response => {
					this.prsTypeList = response.data
				})
				.catch(error => {
					console.log('error catch prstype == ', error.message)
				})

				// GET LIST prsfunction
				await this.$store.dispatch('axiosGet', {
					domain: 'prsfunction'
				})
				.then(response => {
					this.prsFunctionList = response.data
				})
				.catch(error => {
					console.log('error catch prsFunctionList == ', error.message)
				})

				// GET LIST prsServiceList
				await this.$store.dispatch('axiosGet', {
					domain: 'prsservice'
				})
				.then(response => {
					this.prsServiceList = response.data
				})
				.catch(error => {
					console.log('error catch prsServiceList == ', error.message)
				})
				
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})
				if(this.type){
					this.instance.prsType = [this.type]
					this.prsTypeList = this.prsTypeList.filter(item => item.id == this.type)
					this.pageTitle = this.$t('prsperson.list.'+this.prsTypeList[0].typeCode.toLowerCase());
					this.search()
				}
			}
			this.reset()
		},
		methods: {
			reset(){
				this.instance = {
					typeCivility: [],
					prsFunction: [],
					prsStore:[],

					firstName: '',
					lastName: '',
					
					paySup: '',
					payEq: '',
					payInf: '',

					active: '',
					dateEntryAfter:'',
					dateEntryBefore:'',
				};
				if(this.type)
					this.instance.prsType = [this.type]
				else
					this.instance.prsType = []
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";
				
				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list.all')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';

				// Date super
				strParamsForms = strParamsForms+"&params1=dateEntry&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				
				// Date inf
				strParamsForms = strParamsForms+"&params2=dateEntry&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}

				strParamsForms = strParamsForms+"&params3=prsFunction.id&valParams3="+this.instance.prsFunction +"&logParams3=inL"
				if(this.instance.prsFunction && this.instance.prsFunction.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.prsFunctionList, this.instance.prsFunction, 'functionName')
					detailsTopC1 = '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.functionName')+'(s) : </i><b>'+strLibs + '</b>'
				}
				
				strParamsForms = strParamsForms+"&params4=prsStore.id&valParams4="+this.instance.prsStore +"&logParams4=eqL"
				if(this.instance.prsStore && this.instance.prsStore.length >0 ){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.prsStoreList, this.instance.prsStore, 'storeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsStore')+'(s) : </i><b>'+strLibs + '</b>'
				}

				// strParamsForms = strParamsForms+"&aliasList=_prsPerson"
				strParamsForms = strParamsForms+"&params5=prsType.id&valParams5="+this.instance.prsType +"&logParams5=inL"
				
				if(this.instance.prsType && this.instance.prsType.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.prsTypeList, this.instance.prsType, 'typeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsType')+'(s) : </i><b>'+strLibs + '</b>'
				}
					
				// Amout super
				strParamsForms = strParamsForms+"&params6=pay&valParams6="+this.instance.paySup+"&logParams6=geDo"
				if(this.instance.paySup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.pay')+' >= </i><b>'+this.$store.getters.formatAmount(this.instance.paySup) + '</b>'
				}
				// Amout equal
				strParamsForms = strParamsForms+"&params7=pay&valParams7="+this.instance.payEq+"&logParams7=eqDo"
				if(this.instance.payEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.pay')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.payEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params8=pay&valParams8="+this.instance.payInf+"&logParams8=leDo"
				if(this.instance.payInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.pay')+' <;= </i><b> '+this.$store.getters.formatAmount(this.instance.payInf) + '</b>'
				}

				strParamsForms = strParamsForms+"&params10=active&valParams10="+this.instance.active+"&logParams10=eqB"

				strParamsForms = strParamsForms+"&params11=firstName&valParams11="+this.instance.firstName +"&logParams11=ilike"
				strParamsForms = strParamsForms+"&params12=lastName&valParams12="+this.instance.lastName +"&logParams12=ilike"
				

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.
				setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(items) {
				// Si items null, On ramène les rows de datatable 
				if(!items)
					items = this.$refs.componentDatatableInstance.getRows()
				this.chartData = [ ["Stat Genre", "Nbre de tiers par genre"] ]
				var dataList = [];
				if(this.typeStat === 'typeCivility' ){
					this.typeCivilityList.forEach(type => {
						dataList.push([type.id, 0]);
					});
					// this.rows.forEach(row => {
					items?.forEach(row => {
						dataList.forEach(item => {
							if(item[0] === row.typeCivility)
								item[1] = item[1] + 1;
						});
					});
				}
			
				for (var i = 0, len = dataList.length; i < len; i++) {
					this.chartData.push(dataList[i]);	
				}		
			},
			async changeMat(){
				this.$store.dispatch('loading', 'Changement des Matricules')
				await this.$store.dispatch('axiosPost', {
					domain: 'prsperson/changemat',
				})
				.then(res => {
					let msg = 'MAT CHANGED'
					this.$store.dispatch('showToast', {
						type: 'success', message: this.$t('toast.created.message', { obj: msg})
					});
				})
				.catch(error => {
					// console.log('Error', error.response)
					this.$store.getters.getErrorMsgFormatted(error);
					this.$store.dispatch('unloading')
				})
				this.$store.dispatch('unloading')
			}
		}
		
	}

</script>